import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				display: "flex",
				marginTop: 10,
				alignItems: "center",
				justifyContent: "space-between"
			},
			title: {
				color: theme.palette.grey[50],
				fontSize: 13
			},
			value: {
				fontWeight: 500,
				fontSize: 13,
				textTransform: "lowercase"
			}
		}),
	{
		name: "FieldBody",
		index: 1
	}
);

export default useStyles;
